import { render, staticRenderFns } from "./ReferralBar.vue?vue&type=template&id=c20d307c&"
import script from "./ReferralBar.vue?vue&type=script&lang=js&"
export * from "./ReferralBar.vue?vue&type=script&lang=js&"
import style0 from "./ReferralBar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports